(() => {
  const hydrate = (scope) => {
    scope.querySelectorAll?.('img[data-alvento-src]').forEach((image) => {
      if (image.dataset.alventoSrcset) image.srcset = image.dataset.alventoSrcset;
      image.src = image.dataset.alventoSrc;
      delete image.dataset.alventoSrc;
      delete image.dataset.alventoSrcset;
    });
  };

  const openMedia = (event) => {
    const item = event.target.closest?.('.menu-list__list-item');
    if (item) hydrate(item);
  };

  document.addEventListener('pointerover', openMedia, { passive: true });
  document.addEventListener('focusin', openMedia);
  document.addEventListener('click', openMedia);
})();
